/*
 * @Descripttion:
 * @version:
 * @Author: pengmiaopei
 * @Date: 2021-07-24 15:21:44
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2021-08-31 14:03:18
 * @Description: file content
 * @FilePath: \Design_Vue_pmp\src\config\index.js
 */
/**
 * @description 4个子配置，vue/cli配置|通用配置|主题配置|网络配置导出
 */
const cli = require('./cli.config')
const setting = require('./setting.config')
const theme = require('./theme.config')
const network = require('./net.config')
//module.exports = Object.assign({}, cli, setting, theme, network)

module.exports = Object.assign({}, cli, setting, theme, network)
